import _ from 'lodash';

interface Options {
  appId: string;
  userName: string;
}

const IGNORE_ERROR_MSG = [
  `SyntaxError: Unexpected token '<'`, // iconFont的js加载报错问题忽略
  `SyntaxError: Failed to execute 'open' on 'Window'`, // window.open报错忽略
  'Error: Minified React error #185;', // React无限更新循环报错忽略
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded', // ResizeObserver
  'getWidth',
  'formRequiredLost', // 前端表单校验失败时自定义的错误信息
  '"errorFields": [', // 表单必填校验报错忽略
  'ScoutHttpError: Bad Gateway',
  'ScoutHttpError: Unauthorized',
  'ScoutHttpError: Forbidden',
  'Error: 不允许访问',
  '引擎流程节点信息为空',
  '必填', // 表单必填校验报错忽略
  '"errorFields":', // 表单必填校验报错忽略
  'HTTPError: Request failed with status code 401', // 401错误忽略
  '【form-log-tracer】', // 表单日志追踪报错忽略
];

// setTimeout(() => {
//   throw new Error('test error');
//   new Promise(() => {
//     throw new Error('test promise error');
//   });
// }, 2000);

export default (options: Options) => {
  const { appId, userName } = options;

  if (process.env.NODE_ENV === 'development') {
    return;
  }

  if (!window.Scout) {
    return;
  }

  window.Scout.init({
    appId,
    instrumentEnable: {
      fetch: true, // 启动fetch劫持
      xhr: true, // 启动xhr劫持
    },
    routeMap: {},
    requestLogLevel: 1,
    ignoreErrors: [
      (e: any) => {
        const { msg } = e;
        // 无额信息的rejection报错不上报
        if(e.type === 'unhandledrejection' && msg === 'Error') {
          return true;
        }
        return (
          _.isEmpty(msg) ||
          IGNORE_ERROR_MSG.some((defaultMsg: string) =>
            msg.includes(defaultMsg),
          )
        );
      },
    ],
    beforeSend: (requestBody: any) => {
      const chrome = (_.get(requestBody, ['ua']) || '').includes('Chrome');

      if (!chrome) {
        return null;
      }

      const { errors, type } = requestBody;

      if (type === 'error') {
        if (!Array.isArray(errors) || !errors.length) {
          return requestBody;
        }

        const hasFilterError = errors.some(
          (err) => ['CustomError', 'AxiosError', 'ServiceError', 'ScoutHttpError'].includes(err.errorType)
        );

        if (hasFilterError) {
          return null;
        }
      }

      return requestBody;
    },
  });

  try {
  window.Scout.setUserData({ userName });
    window.Scout.setMetaData({ versionTag: window.$versionTag || 'dev' });
  } catch (error) {
    console.error(error);
  }
};

export const ScoutCaptureError = (error: any, name?: string) => {
  if (process.env.NODE_ENV === 'development') {
    return;
  }
  if(window.Scout) {
    let errorInfo = error;
    // 如果是字符串，新建error
    if(typeof error === 'string') {
      errorInfo = new Error(error);
    }
    if(name) {
      errorInfo.name = name;
    }
    window.Scout.captureError(errorInfo);
  }
};

